import { FormControl, Autocomplete, TextField } from "@mui/material";
import { useState } from "react";
import vehiclesService from "services/vehiclesService";

const VehicleUnitNumberSearch = ({ unitNumber = undefined, onChange, marginLeft = 0, marginRight = 0, marginTop = 2 }) => {
	const [unitNumbers, setUnitNumbers] = useState([]);

	return (
		<FormControl sx={{ mt: marginTop ?? 0, ml: marginLeft ?? 0, mr: marginRight ?? 0,  p: 0, minWidth: 125 }}>
			<Autocomplete
				id="unitNumber"
				sx={{
					"& .MuiOutlinedInput-root": {
						padding: "4px!important",
					},
				}}
				freeSolo
				autoHighlight={true}
				getOptionLabel={(o) => o.name}
				options={unitNumbers}
				value={unitNumber ?? null}
				onInputChange={(e, value, reason) => {
					if(reason ==='clear'){
						onChange({name:'', value:null});
					} else {
						vehiclesService.searchVehicleUnitNumber(value).then((r) => setUnitNumbers(r));
					}
				}}
				renderInput={(params) => <TextField {...params} label="Unit Number" />}
				onChange={(e, value) => onChange(value)}
			/>
		</FormControl>
	);
};
export default VehicleUnitNumberSearch;
